/**
 * Runtime configuration from Vite environment variables.
 * Set VITE_DEMO_MODE=true at build time for static demo deployments.
 */
export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '/api';

const publicAsset = (file: string) =>
  `${import.meta.env.BASE_URL}${file.replace(/^\//, '')}`;

/** Public asset path for the brand logo (place file in /public) */
export const logoPath = import.meta.env.VITE_LOGO_PATH ?? publicAsset('logo.png');

/** Auth pages use the PNG logo from /public */
export const authLogoPath =
  import.meta.env.VITE_AUTH_LOGO_PATH ?? publicAsset('logo.png');

export const logoFallbackPath = publicAsset('logo.svg');
